module.exports = __webpack_public_path__ + "img/poe-logo.0c8c74bb.svg";